import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@pondigitalsolutions/pon-component-library";
import { useIsStoryblokEditor } from "@hooks/useIsStoryblokEditor";

/**
 * A slim, editor-only banner shown when the app is rendered inside the Storyblok Visual Editor.
 * It makes it unmistakable to the CMS user that they are viewing unsaved draft content, so a
 * draft-only page or a not-yet-published change is never mistaken for the live site. Renders
 * nothing outside an editor session.
 */
export const EditorPreviewBanner: React.FC = () => {
  const { t } = useTranslation();
  const isEditor = useIsStoryblokEditor();

  if (!isEditor) return null;

  return (
    <output className="block w-full bg-primary-500 px-4 py-2 text-center text-white dark:bg-primary-600">
      <Typography size="sm" className="font-semibold">
        {t("EditorPreviewBanner.label")}
      </Typography>
    </output>
  );
};
